import TimeMe from 'timeme.js';
import {Cookies} from '../shared/cookies-extended';
import {globalActions} from '../../js/store/global-actions';

function initCookeBaseTimerControls(app) {
    app.component('cookie-based-timer', {
        data() {
            return {
                cookieCheckTime: 5,
                idleTimeoutInSeconds: 30,
                pageSpentTimeOnPreviousTick: 0,
                timerIndex: 0,
            };
        },
        props: {
            cookie: {
                type: String,
                required: true,
            },
            cookieExpiration: {
                type: Number,
                default: 10 * 60,
            },
            timers: {
                type: Array,
                required: true,
                default: () => [0],
            },
        },
        computed: {
            sortedTimers() {
                return [...new Set(this.timers)].filter((timer) => !isNaN(parseInt(timer))).sort((a, b) => a - b);
            },
        },
        methods: {
            initTimer() {
                if (this.sortedTimers.length > 0 && this.sortedTimers.at(-1) > 0) {
                    this.startCookieTimer();
                }
            },
            getExpirationDatetime() {
                const date = new Date();
                date.setTime(date.getTime() + (this.cookieExpiration * 1000));
                return date;
            },
            setCurrentIndex(previousSpentTime) {
                this.timerIndex = this.sortedTimers.findIndex((timerTimeout) => timerTimeout > previousSpentTime);
            },
            getPreviousSpentTime() {
                if (!this.cookie) {
                    return 0;
                }

                const radix = 10;
                const value = parseInt(Cookies.get(this.cookie), radix);
                return isNaN(value) ? 0 : value;
            },
            measureSpentTime() {
                const summarySpentTime = this.getSummarySpentTime();
                Cookies.set(this.cookie, summarySpentTime, {expires: this.getExpirationDatetime()});
                if (summarySpentTime >= this.sortedTimers[this.timerIndex]) {
                    globalActions.triggerTimerTimeout(this.sortedTimers[this.timerIndex]);
                }

                this.enqueueNextTick(summarySpentTime);
            },
            getSummarySpentTime() {
                const pageSpentTime = TimeMe.getTimeOnCurrentPageInSeconds();
                const summarySpentTime = this.getPreviousSpentTime() + pageSpentTime - this.pageSpentTimeOnPreviousTick;
                this.pageSpentTimeOnPreviousTick = pageSpentTime;
                return summarySpentTime;
            },
            enqueueNextTick(summarySpentTime) {
                if (summarySpentTime > this.sortedTimers.at(-1)) {
                    this.resetTimer();
                    TimeMe.callAfterTimeElapsedInSeconds(this.cookieCheckTime, this.measureSpentTime);
                } else {
                    this.setCurrentIndex(summarySpentTime);
                    TimeMe.callAfterTimeElapsedInSeconds(this.cookieCheckTime + this.pageSpentTimeOnPreviousTick, this.measureSpentTime);
                }
            },
            startCookieTimer() {
                const previousSpentTime = this.getPreviousSpentTime();
                TimeMe.initialize({
                    currentPageName: this.cookie,
                    idleTimeoutInSeconds: this.idleTimeoutInSeconds,
                });
                previousSpentTime < this.sortedTimers.at(-1) ?
                    this.setCurrentIndex(previousSpentTime) :
                    this.resetTimer();
                TimeMe.callAfterTimeElapsedInSeconds(this.cookieCheckTime, this.measureSpentTime);
            },
            resetTimer() {
                TimeMe.resetRecordedPageTime(this.cookie);
                TimeMe.stopTimer(this.cookie);
                Cookies.set(this.cookie, 0, {expires: this.getExpirationDatetime()});
                this.pageSpentTimeOnPreviousTick = 0;
                this.timerIndex = 0;
                TimeMe.startTimer(this.cookie);
            },
        },
        mounted() {
            this.initTimer();
        },
        render() {
            return null;
        },
    });
}

export default initCookeBaseTimerControls;
